import React,{useState} from 'react'
import HeroCard from '../../components/causeBranding/HeroCard'
import PartnersLogo from '../../components/causeBranding/PartnersLogo'
import Millennials from '../../components/causeBranding/Millennials'
import HowItWorks from '../../components/causeBranding/HowItWorks'
import Testimony from '../../components/home/testimony/Testimony'
import Accordion from '../../components/causeBranding/Accordion'
import CauseCard from '../../components/causeBranding/CauseCard'
import './CauseBranding.css'
import '../../components/causeBranding/HeroCard.css'
import Popup from '../../components/popup/Popup'
import { images } from '../../assets'


function CauseBranding() {

  const [showPopup, setShowPopup] = useState(false);

  // Function to toggle the visibility of the pop-up form
  const togglePopup = () => {
    setShowPopup(!showPopup);
  };

  const customClass={
      heroTextTitle:"heroTextTitle",
      heroTextInfo:"heroTextInfo",
      customButton:"customButton",
      handMobile:"handMobile",
      causeMobile:"causeMobile"
  };

  const faqs = [
    {
      question: 'What is Cause branding?',
      answer: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Ratione modi incidunt doloremque eius recusandae quibusdam nihil beatae laudantium nesciunt praesentium?Lorem ipsum dolor sit amet, consectetur adipisicing elit. Ratione modi incidunt doloremque eius recusandae quibusdam nihil beatae laudantium nesciunt praesentium?'
    },
    {
      question: 'How do I benefit with it?',
      answer: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Ratione modi incidunt doloremque eius recusandae quibusdam nihil beatae laudantium nesciunt praesentium?'
    },
    {
      question: 'What is the cost of cause branding?',
      answer: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Ratione modi incidunt doloremque eius recusandae quibusdam nihil beatae laudantium nesciunt praesentium?'
    },
    {
      question: 'How do I get started?',
      answer: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Ratione modi incidunt doloremque eius recusandae quibusdam nihil beatae laudantium nesciunt praesentium?'
    }
   
  ];

  const millennialsClass={
    boxStats:"boxData",
    analyticsGirl:"analyticsgirl"
  }


  return (
    <>
    <HeroCard
      title="Cause Branding"
      description="Involve a community of millions of healthy people with your social good work. Join the 30+ companies who contribute their CSR to match the steps of our community."
      statistics={[
        { label: 'Community', value: '4M+' },
        { label: 'Impression', value: '30M+' },
        { label: 'Monthly Socialmedia shares', value: '400K+' }
      ]}
      buttonText="Request a call back"
      className={customClass}
      onButtonClick={togglePopup}
      handMobileSrc={images.handMobile}
      causeMobileSrc={images.causeMobile}
    />
    <PartnersLogo className="partnersLogo" />
    <Millennials
        mTitle="Millennials and GenZ worldwide are looking for"
        mTitleMessage="A healthier lifestyle and more meaning in life."
        mSubText="On Impact, every step our 300K+ monthly active users take for their own health is creating a positive impact in the wellbeing of someone else in need. So most of our users not only love and share the app generously, but are also stay happily hooked on to Impact for years. "
        boxTitles={["TOTAL USERS COMMUNITY", "CSR PARTNERS", "HOME PAGE VIEWS", "MONTHLY SOCIAL SHARES", "DAILY ENGAGEMENT TIME"]}
        boxData={["4 Million+", "30+", "324K+", "400K+", "10 mins"]}
        dailyActiveUsers="DAILY ACTIVE USERS"
        dailyActiveUsersData="105K"
        className={millennialsClass}
        analyticsGirl={images.analyticGirl}
  
      />
    <HowItWorks />
    {/* <Testimony /> */}
    {/* <Accordion faqs={faqs} Faqs="Faqs" /> */}
    <CauseCard onInterestClick={togglePopup} />
    <Popup showPopup={showPopup} togglePopup={togglePopup} />
    </>
    
  )
}

export default CauseBranding
